/**
 * Increment when panel tab migration logic changes so persisted configs without a matching version
 * re-run {@link migrateBlotterTabsToPanelParams}.
 */
export const BLOTTER_PANEL_TABS_MIGRATION_VERSION = 1;

/** Run blotter tab migration when stored version is missing or below the current migration version. */
export function shouldRunBlotterTabsMigration(config: { blotterTabsMigrationVersion?: number }): boolean {
  const v = config.blotterTabsMigrationVersion;
  return v == null || v < BLOTTER_PANEL_TABS_MIGRATION_VERSION;
}
